// function loadZXingLibrary() {
//     return new Promise((resolve, reject) => {
//         if (window.ZXing) {
//             // Library already loaded
//             resolve(window.ZXing);
//             return;
//         }

//         const script = document.createElement('script');
//         script.src = 'https://unpkg.com/@zxing/library@latest';
//         script.onload = () => resolve(window.ZXing);
//         script.onerror = () => reject(new Error('Failed to load ZXing library'));
//         document.head.appendChild(script);
//     });
// }

// async function redirectToProductUrl(barcode) {
//   const url = "https://westside-api.wizsearch.in/v1/products/filter";

//   const headers = {
//     "Content-Type": "application/json;charset=UTF-8",
//     "x-api-key": "SzVuZVRLNUtKUDA5dlN5QUxBblUvTkdrY1c0bHpIanFWQnFVa1pBVklCZ3ZJWGtMdW5KdGZrMzM4ODJDM25FUGVQN2NxWlh3TVdoNFJ4UVptdXlKS2c9PQ==",
//     "x-store-id": "2532b1c019c111f090410a0c8095feae",
//   };

//   const filters = {
//     attributes: {
//       product_barcode: [String(barcode)], // ✅ dynamic scanned barcode
//     },
//     sort: [
//       { field: "relevance", order: "asc" },
//       { field: "product_published_at:datetime", order: "desc" },
//     ],
//     page: 1,
//     type: "DEFAULT",
//     facets: [
//       { label: "Categories", key: "product_product_type", position: "left", order: 0 },
//       { label: "Size", key: "sizes", position: "left", order: 1 },
//       { label: "Brand", key: "brands", position: "left", order: 2 },
//       { label: "Color", key: "colors", position: "left", order: 3 },
//       { label: "Gender", key: "genders", position: "left", order: 4 },
//       { label: "Price", key: "sellingPrice", position: "left", order: 5 },
//       { label: "Design", key: "product_value_tags_design", position: "left", order: 6 },
//       { label: "Fabric/Material", key: "product_value_tags_fabric_material", position: "left", order: 7 },
//       { label: "Occasion", key: "product_value_tags_occasion", position: "left", order: 8 },
//       { label: "Fit", key: "product_value_tags_fit", position: "left", order: 9 },
//       { label: "Neck Design", key: "product_value_tags_neck_design", position: "left", order: 10 },
//       { label: "Closure", key: "product_value_tags_closure", position: "left", order: 11 },
//       { label: "Sleeve Length", key: "product_value_tags_sleeve_length", position: "left", order: 12 },
//       { label: "Sleeve Type", key: "product_value_tags_sleeve_type", position: "left", order: 13 },
//       { label: "Dress Length", key: "product_value_tags_length", position: "left", order: 14 },
//       { label: "Discount", key: "product_wizzy_sale_custom", position: "left", order: 0 }
//     ],
//     getAllVariants: "false",
//     swatch: [{ key: "product_Multi_Variant_Product" }],
//     currency: "INR",
//     productsCount: 24,
//     showOOSProductsInOrder: "true",
//     inStock: ["true"],
//   };

//   const body = {
//     filters: JSON.stringify(filters), // ✅ must be string
//     group: "page",
//     fW: "yes",
//   };

//   try {
//     const response = await fetch(url, {
//       method: "POST",
//       headers,
//       body: JSON.stringify(body),
//     });

//     if (!response.status) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const data = await response.json();
//     const productUrl = data.payload.result[0].url;
//     window.location.href = productUrl;
//     // console.log("Response:", data);
//   } catch (err) {
//     console.error("Fetch error:", err);
//   }

// }

// document.addEventListener("DOMContentLoaded", function () {
//   const previewImg = document.getElementById("wizzy-barcode-preview-img");
//   const dropZone = document.getElementById("wizzyBarcodeDropZone");
//   const uploadInput = document.getElementById("wizzyBarcodeUploadInput");

//   async function openModal() {
//     const modal = document.getElementById("wizzyBarcodeModalOverlay");
//     modal.style.display = "flex";

//     const video = document.getElementById("wizzyBarcodeVideo");
//     const isMobile = window.innerWidth < 768;

//     if (isMobile) {
//       // 📱 Mobile: live scanning
//       // previewImg.style.display = "none";
//       video.style.display = "block";

//       try {
//         await loadZXingLibrary();
//         window.barcodeReader = new ZXing.BrowserMultiFormatReader();

//         window.barcodeReader.decodeFromVideoDevice(
//           null, // auto pick rear camera
//           "wizzyBarcodeVideo",
//           async (result, err) =>  {
//             if (result) {
//               // console.log("Scanned:", result.getText());
//               // const url = `https://www.westside.com/pages/search?&product_barcode[]=${result.getText()}`;
//               redirectToProductUrl(result);
//               // executeWizzyFiltersFromURL(url);
//               closeModal();
//             }
//             if (err && !(err instanceof ZXing.NotFoundException)) {
//               console.warn("Scan error:", err);
//             }
//           }
//         );
//       } catch (err) {
//         console.error("Camera init failed:", err);
//         alert("Unable to access camera");
//       }

//     } else {
//       // 💻 Desktop: behave as before
//       if (previewImg?.src && previewImg?.src !== window.location.href) {
//         previewImg.style.display = "block";
//       }
//       if (video) video.style.display = "none";
//     }
//   }


//   document.getElementById("wizzyBarcodeUploadInput").addEventListener("change", async (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const reader = new FileReader();
//   reader.readAsDataURL(file);

//   reader.onload = async function (event) {
//     const img = new Image();
//     img.src = event.target.result;

//     img.onload = async () => {
//       try {
//         // Create canvas to normalize orientation & resize
//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d");

//         let width = img.width;
//         let height = img.height;

//         // Resize down if too big (helps ZXing performance)
//         const maxSize = 1000;
//         if (width > maxSize || height > maxSize) {
//           const scale = Math.min(maxSize / width, maxSize / height);
//           width = Math.round(width * scale);
//           height = Math.round(height * scale);
//         }

//         canvas.width = width;
//         canvas.height = height;
//         ctx.drawImage(img, 0, 0, width, height);

//         // Convert back to Image for ZXing
//         const processedImg = new Image();
//         processedImg.src = canvas.toDataURL("image/jpeg");

//         processedImg.onload = async () => {
//           await loadZXingLibrary();
//           const codeReader = new ZXing.BrowserBarcodeReader();

//           try {
//             const result = await codeReader.decodeFromImageElement(processedImg);
//             setTimeout(() => {
//               redirectToProductUrl(result);
//               closeModal();
//             }, 1000);
//           } catch (err) {
//             console.error("Barcode not found", err);
//             alert("Barcode not detected.");
//           }
//         };
//       } catch (error) {
//         console.error("Processing error", error);
//         alert("Error processing image.");
//       }
//     };
//   };
// });


//   function closeModal() {
//     const modal = document.getElementById("wizzyBarcodeModalOverlay");
//     const icon = document.querySelector(".wizzy-barcode-upload-icon");
//     const img = document.getElementById("wizzyBarcodePreviewImg");
//     const dropZoneText = document.querySelector(".wizzy-barcode-modal-title");
//     modal.style.display = "none";
  
//     // Reset the preview image
//     if (img) {
//       img.src = "";
//       img.style.display = "none";
//     }

//     if (dropZoneText) dropZoneText.style.display = "block"; 

//     // Show the icon again
//     if (icon) {
//       icon.style.display = "block";
//     }
  
//     // Remove any dragover state if it’s still applied
//     dropZone.classList.remove("dragover");
//   }


//   function handleBarcodeImage(file) {
//     const imgURL = URL.createObjectURL(file);

//     const icon = document.querySelector(".wizzy-barcode-upload-icon");
//     const img = document.getElementById("wizzyBarcodePreviewImg");
//     const dropZoneText = document.querySelector(".wizzy-barcode-modal-title");
//     if (dropZoneText) dropZoneText.style.display = "none";
//     if (icon) icon.style.display = "none";
//     if (img) {
//       img.src = imgURL;
//       img.style.display = "block";
//     }
//   }

//   uploadInput.addEventListener("change", function () {
//     if (this.files && this.files[0]) {
//       handleBarcodeImage(this.files[0]);
//       openModal();
//     }
//     this.value = null;
//   });

// //   dropZone.addEventListener("click", (e) => {
// //   if (window.innerWidth < 768) {
// //     // On mobile: directly open camera
// //     uploadInput.setAttribute("capture", "environment");
// //   } else {
// //     // On desktop: allow file picker
// //     uploadInput.removeAttribute("capture");
// //   }
// //   uploadInput.click();
// // });

// dropZone.addEventListener("click", (e) => {
//   const isMobile = window.innerWidth < 768;
//   if (isMobile) {
//     // 📱 Mobile: open modal with live scanning
//     openModal();
//   } else {
//     // 💻 Desktop: use upload flow
//     uploadInput.removeAttribute("capture");
//     uploadInput.click();
//   }
// });


//   dropZone.addEventListener("dragover", (e) => {
//     e.preventDefault();
//     dropZone.classList.add("dragover");
//   });

//   dropZone.addEventListener("dragleave", () => {
//     dropZone.classList.remove("dragover");
//   });

//   dropZone.addEventListener("drop", (e) => {
//     e.preventDefault();
//     dropZone.classList.remove("dragover");
//     const files = e.dataTransfer.files;
//     if (files.length && files[0].type.startsWith("image/")) {
//       handleBarcodeImage(files[0]);
//       openModal();
//     }
//   });

//   // Click handler to trigger modal
//   $("body").on("click", ".wizzy-barcode-search-button", function () {
//     if (window.innerWidth < 768) {
//       $('details').removeAttr('open');
//     }
//     openModal();
//   });

//   // Expose modal controls globally
//   window.wizzyBarcodeModal = openModal;
//   window.closeWizzyBarcodeModal = closeModal;
// });
function loadZXingLibrary() {
    return new Promise((resolve, reject) => {
        if (window.ZXing) {
            resolve(window.ZXing);
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://unpkg.com/@zxing/library@latest';
        script.onload = () => resolve(window.ZXing);
        script.onerror = () => reject(new Error('Failed to load ZXing library'));
        document.head.appendChild(script);
    });
}

// Show loading state
function showLoading() {
  const loadingEl = document.getElementById('wizzyBarcodeLoading');
  if (loadingEl) {
    loadingEl.style.display = 'flex';
  }
}

// Hide loading state
function hideLoading() {
  const loadingEl = document.getElementById('wizzyBarcodeLoading');
  if (loadingEl) {
    loadingEl.style.display = 'none';
  }
}

// Close modal function - defined globally
function closeModal() {
  const modal = document.getElementById("wizzyBarcodeModalOverlay");
  const icon = document.querySelector(".wizzy-barcode-upload-icon");
  const img = document.getElementById("wizzyBarcodePreviewImg");
  const dropZoneText = document.querySelector(".wizzy-barcode-modal-title");
  const video = document.getElementById("wizzyBarcodeVideo");
  const dropZone = document.getElementById("wizzyBarcodeDropZone");

  if (modal) modal.style.display = "none";
  hideLoading();

  // Reset processing flags
  window.barcodeProcessing = false;
  window.barcodeRedirecting = false;

  if (window.barcodeReader) {
    try {
      window.barcodeReader.reset();
      window.barcodeReader = null;
    } catch (e) {
      // Ignore cleanup errors
    }
  }

  if (video) {
    video.pause();
    video.srcObject = null;
    video.style.display = "none";
  }

  if (img) {
    img.src = "";
    img.style.display = "none";
  }
  if (dropZoneText) dropZoneText.style.display = "block"; 
  if (icon) icon.style.display = "block";
  if (dropZone) dropZone.classList.remove("dragover");
}

async function redirectToProductUrl(barcode) {
  const url = "https://westside-api.wizsearch.in/v1/products/filter";

  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
    "x-api-key": "SzVuZVRLNUtKUDA5dlN5QUxBblUvTkdrY1c0bHpIanFWQnFVa1pBVklCZ3ZJWGtMdW5KdGZrMzM4ODJDM25FUGVQN2NxWlh3TVdoNFJ4UVptdXlKS2c9PQ==",
    "x-store-id": "2532b1c019c111f090410a0c8095feae",
  };

  const filters = {
    attributes: {
      product_barcode: [String(barcode)],
    },
    sort: [
      { field: "relevance", order: "asc" },
      { field: "product_published_at:datetime", order: "desc" },
    ],
    page: 1,
    type: "DEFAULT",
    facets: [
      { label: "Categories", key: "product_product_type", position: "left", order: 0 },
      { label: "Size", key: "sizes", position: "left", order: 1 },
      { label: "Brand", key: "brands", position: "left", order: 2 },
      { label: "Color", key: "colors", position: "left", order: 3 },
      { label: "Gender", key: "genders", position: "left", order: 4 },
      { label: "Price", key: "sellingPrice", position: "left", order: 5 },
      { label: "Design", key: "product_value_tags_design", position: "left", order: 6 },
      { label: "Fabric/Material", key: "product_value_tags_fabric_material", position: "left", order: 7 },
      { label: "Occasion", key: "product_value_tags_occasion", position: "left", order: 8 },
      { label: "Fit", key: "product_value_tags_fit", position: "left", order: 9 },
      { label: "Neck Design", key: "product_value_tags_neck_design", position: "left", order: 10 },
      { label: "Closure", key: "product_value_tags_closure", position: "left", order: 11 },
      { label: "Sleeve Length", key: "product_value_tags_sleeve_length", position: "left", order: 12 },
      { label: "Sleeve Type", key: "product_value_tags_sleeve_type", position: "left", order: 13 },
      { label: "Dress Length", key: "product_value_tags_length", position: "left", order: 14 },
      { label: "Discount", key: "product_wizzy_sale_custom", position: "left", order: 0 }
    ],
    getAllVariants: "false",
    swatch: [{ key: "product_Multi_Variant_Product" }],
    currency: "INR",
    productsCount: 24,
    showOOSProductsInOrder: "true",
    inStock: ["true"],
  };

  const body = {
    filters: JSON.stringify(filters),
    group: "page",
    fW: "yes",
  };

  // Prevent duplicate requests
  if (window.barcodeProcessing) {
    return;
  }
  window.barcodeProcessing = true;

  try {
    showLoading();
    
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.payload && data.payload.result && data.payload.result[0] && data.payload.result[0].url) {
      const productUrl = data.payload.result[0].url;
      
      // ✅ SET FLAG BEFORE REDIRECT - This prevents error alerts
      window.barcodeRedirecting = true;
      
      // Stop the camera before redirect (important for mobile)
      if (window.barcodeReader) {
        try {
          window.barcodeReader.reset();
        } catch (e) {
          // Ignore errors during cleanup
        }
      }
      
      window.location.href = productUrl;
    } else {
      window.barcodeProcessing = false;
      hideLoading();
      alert("Product not found for this barcode.");
      closeModal();
    }
  } catch (err) {
    console.error("Fetch error:", err);
    window.barcodeProcessing = false;
    
    // ✅ ONLY SHOW ALERT IF NOT REDIRECTING
    if (!window.barcodeRedirecting) {
      hideLoading();
      alert("Error while fetching barcode.");
      closeModal();
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const previewImg = document.getElementById("wizzy-barcode-preview-img");
  const dropZone = document.getElementById("wizzyBarcodeDropZone");
  const uploadInput = document.getElementById("wizzyBarcodeUploadInput");

  function closeModal() {
    const modal = document.getElementById("wizzyBarcodeModalOverlay");
    const icon = document.querySelector(".wizzy-barcode-upload-icon");
    const img = document.getElementById("wizzyBarcodePreviewImg");
    const dropZoneText = document.querySelector(".wizzy-barcode-modal-title");
    const video = document.getElementById("wizzyBarcodeVideo");

    modal.style.display = "none";
    hideLoading();

    // Reset processing flags
    window.barcodeProcessing = false;
    window.barcodeRedirecting = false;

    if (window.barcodeReader) {
      try {
        window.barcodeReader.reset();
        window.barcodeReader = null;
      } catch (e) {
        // Ignore cleanup errors
      }
    }

    if (video) {
      video.pause();
      video.srcObject = null;
      video.style.display = "none";
    }

    if (img) {
      img.src = "";
      img.style.display = "none";
    }
    if (dropZoneText) dropZoneText.style.display = "block"; 
    if (icon) icon.style.display = "block";
    dropZone.classList.remove("dragover");
  }

  async function openModal() {
    const modal = document.getElementById("wizzyBarcodeModalOverlay");
    modal.style.display = "flex";

    // Reset flags when opening modal
    window.barcodeProcessing = false;
    window.barcodeRedirecting = false;

    const video = document.getElementById("wizzyBarcodeVideo");
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      video.style.display = "block";

      try {
        await loadZXingLibrary();
        window.barcodeReader = new ZXing.BrowserMultiFormatReader();

        window.barcodeReader.decodeFromVideoDevice(
          null,
          "wizzyBarcodeVideo",
          async (result, err) => {
            if (result && !window.barcodeProcessing) {
              redirectToProductUrl(result.getText());
            }
            if (err && !(err instanceof ZXing.NotFoundException)) {
              console.warn("Scan error:", err);
            }
          }
        );
      } catch (err) {
        console.error("Camera init failed:", err);
        alert("Unable to access camera");
      }

    } else {
      if (previewImg?.src && previewImg?.src !== window.location.href) {
        previewImg.style.display = "block";
      }
      if (video) video.style.display = "none";
    }
  }

  document.getElementById("wizzyBarcodeUploadInput").addEventListener("change", async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = async function (event) {
      const img = new Image();
      img.src = event.target.result;

      img.onload = async () => {
        try {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          const maxSize = 1000;
          if (width > maxSize || height > maxSize) {
            const scale = Math.min(maxSize / width, maxSize / height);
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          const processedImg = new Image();
          processedImg.src = canvas.toDataURL("image/jpeg");

          processedImg.onload = async () => {
            await loadZXingLibrary();
            const codeReader = new ZXing.BrowserBarcodeReader();

            try {
              const result = await codeReader.decodeFromImageElement(processedImg);
              redirectToProductUrl(result.getText());
            } catch (err) {
              console.error("Barcode not found", err);
              alert("Barcode not detected.");
            }
          };
        } catch (error) {
          console.error("Processing error", error);
          alert("Error processing image.");
        }
      };
    };
  });

  function handleBarcodeImage(file) {
    const imgURL = URL.createObjectURL(file);

    const icon = document.querySelector(".wizzy-barcode-upload-icon");
    const img = document.getElementById("wizzyBarcodePreviewImg");
    const dropZoneText = document.querySelector(".wizzy-barcode-modal-title");
    if (dropZoneText) dropZoneText.style.display = "none";
    if (icon) icon.style.display = "none";
    if (img) {
      img.src = imgURL;
      img.style.display = "block";
    }
  }

  uploadInput.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      handleBarcodeImage(this.files[0]);
      openModal();
    }
    this.value = null;
  });

  dropZone.addEventListener("click", (e) => {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      openModal();
    } else {
      uploadInput.removeAttribute("capture");
      uploadInput.click();
    }
  });

  dropZone.addEventListener("dragover", (e) => {
    e.preventDefault();
    dropZone.classList.add("dragover");
  });

  dropZone.addEventListener("dragleave", () => {
    dropZone.classList.remove("dragover");
  });

  dropZone.addEventListener("drop", (e) => {
    e.preventDefault();
    dropZone.classList.remove("dragover");
    const files = e.dataTransfer.files;
    if (files.length && files[0].type.startsWith("image/")) {
      handleBarcodeImage(files[0]);
      openModal();
    }
  });

  $("body").on("click", ".wizzy-barcode-search-button", function () {
    if (window.innerWidth < 768) {
      $('details').removeAttr('open');
    }
    openModal();
  });

  window.wizzyBarcodeModal = openModal;
  window.closeWizzyBarcodeModal = closeModal;
});